import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ACCOUNT_SUBDOMAIN } from "@Client/@Modules/main/store/account/account-getters";
import { mapGetters } from "vuex";
import { getContactData } from "../api/key-contacts-api";
import PageHeader from "@Shared/components/general/page-header.vue";
import KeyContactModal from "./key-contact-modal.vue";
import KeyContactLoader from "./key-contact-loader.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "KeyContactsContainer",
  title() {
    return this.$t("sidebar.sections.keyContacts");
  },
  components: {
    PageHeader,
    KeyContactModal,
    KeyContactLoader
  },
  data() {
    return {
      keyContact: {},
      loading: true
    };
  },
  computed: _objectSpread({}, mapGetters("AccountStore", [ACCOUNT_SUBDOMAIN])),
  beforeMount() {
    Amplitude.logEvent("Key Contacts - visited");
  },
  async mounted() {
    this.loading = true;
    await this.loadKeyContact();
    this.loading = false;
  },
  methods: {
    async loadKeyContact() {
      const keyContact = await getContactData(this.ACCOUNT_SUBDOMAIN);
      this.$set(this, "keyContact", keyContact);
    }
  }
});